import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-about',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss'
})
export class AboutComponent {
  stats = [
    { label: 'Years of Experience', value: '14+' },
    { label: 'Sq. Ft. Developed', value: '2L' },
    { label: 'Happy Clients', value: '250+' },
    { label: 'Commercial Units Sold', value: '310+' }
  ];

  leadership = [
    {
      id: 1,
      name: 'Rajesh Kumar',
      position: 'Chairman & Founder',
      description: 'With over 18 years in construction, Rajesh founded Velora Infra with a vision to redefine quality and trust in the industry.',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=500&fit=crop',
      expertise: ['Strategic Planning', 'Business Development', 'Quality Standards']
    },
    {
      id: 2,
      name: 'Priya Sharma',
      position: 'Managing Director',
      description: 'Leading operations with 15 years of experience in project management and delivery excellence.',
      image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=500&fit=crop',
      expertise: ['Project Management', 'Operations', 'Client Relations']
    },
    {
      id: 3,
      name: 'Arun Patel',
      position: 'Director - Civil & Structural',
      description: 'Expert in structural design with 12 years of specialized experience in complex infrastructure projects.',
      image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=500&fit=crop',
      expertise: ['Structural Design', 'Infrastructure', 'Technical Planning']
    },
    {
      id: 4,
      name: 'Neha Verma',
      position: 'Director - Architecture & Design',
      description: 'Creative visionary bringing modern design principles to every project while maintaining functionality.',
      image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=500&fit=crop',
      expertise: ['Architecture', 'Interior Design', 'Aesthetic Planning']
    }
  ];

  values = [
    {
      title: 'Excellence',
      description: 'Commitment to the highest standards in every project, every time.'
    },
    {
      title: 'Integrity',
      description: 'Transparent communication and honest dealings with all stakeholders.'
    },
    {
      title: 'Innovation',
      description: 'Embracing modern technologies and sustainable construction practices.'
    },
    {
      title: 'Reliability',
      description: 'Delivering on commitments and building lasting relationships with clients.'
    }
  ];
}
